import { gql } from "@apollo/client";

export const GET_LAN_CONTROLLER_REGISTERS = gql`
  query LanControllers($domain: String!, $limit: Int!, $offset: Int!) {
    controller {
      lanControllers(domain: $domain, limit: $limit, offset: $offset) {
        lan_controller_id
        cpu_id
      }
    }
  }
`

export interface LanControllerRegister  {
  lan_controller_id: number;
  cpu_id: string;
}

export interface LanControllerRegistersResponse {
  controller: {
    lanControllers: LanControllerRegister[]
  }
}